import { STATES } from "../constants/states";

const stateSet = new Set<string>(STATES);

/**
 * The state code a submission enum value is prefixed with (`TX_STEERS_PORTAL` →
 * `"TX"`), or null when it isn't tied to one state. Shared by the submission
 * type and method lookups, which differ only in their overrides.
 */
export function statePrefixOf(enumValue: string): string | null {
  const underscoreIndex = enumValue.indexOf("_");
  if (underscoreIndex < 0) {
    return null;
  }

  const prefix = enumValue.substring(0, underscoreIndex);
  if (prefix.length === 2 && stateSet.has(prefix)) {
    return prefix;
  }

  return null;
}
